import { z } from 'zod';
export const EmbedLoginRequestSchema = z.object({
    accessToken: z.string().min(1),
});
export const SessionUserSchema = z.object({
    box_id: z.number(),
    arbox_users_id: z.number(),
    arbox_users_boxes_id: z.number(),
});
/** Arbox roles allowed to see and operate the safe (כספת) side of register
 *  mode — the כספת and הפקדות לבנק tabs. Everyone else (COACH, BASICMANAGER,
 *  reception, …) is limited to the register-closing tabs. Arbox returns
 *  `user_role` as a comma-separated list of role names, so a user qualifies if
 *  ANY of their roles is in this set. */
export const SAFE_ROLES = ['BOXADMIN'];
/** True iff the given raw Arbox `user_role` string grants safe access. Null /
 *  empty (unknown or roster-filtered low role) → false (deny). */
export function canViewSafe(userRole) {
    if (!userRole)
        return false;
    return userRole
        .split(',')
        .map((s) => s.trim().toUpperCase())
        .filter(Boolean)
        .some((r) => SAFE_ROLES.includes(r));
}
export const EmbedLoginResponseSchema = z.object({
    token: z.string(),
    user: SessionUserSchema,
});
//# sourceMappingURL=auth.js.map